/* globals jQuery, BUILDFORCE, google */
/* eslint-disable @wordpress/no-global-active-element */

/**
 * External dependencies
 */
import CliboardJS from 'clipboard';

/**
 * Internal dependencies
 */
import delegateEventListener from './theme/delegate-event';
import determineTarget from './theme/determine-target';
import toggleElement from './theme/toggle-element';
import setupTabs from './theme/tabs';
import setupAccordions from './theme/accordions';
import setupModals from './theme/modals';
import setupCarousels from './theme/carousels';
import setupDropdowns from './theme/dropdown';
import setupAutocompleteDropdowns from './theme/autocomplete-dropdown';
import setupShareButtons from './theme/share-button';
import setupDirectoryModules from './theme/ajax-directory';

jQuery( $ => {
	const $body = $( 'body' );

	// =========================
	// ! Flag Interaction Method
	// =========================

	function flagMouseUse() {
		document.body.classList.add( 'using-mouse' );
		document.body.classList.remove( 'using-keyboard' );
	}
	document.addEventListener( 'mousemove', flagMouseUse );
	document.addEventListener( 'touchstart', flagMouseUse );
	document.addEventListener( 'keydown', event => {
		if ( event.key === 'Tab' ) {
			document.body.classList.remove( 'using-mouse' );
			document.body.classList.add( 'using-keyboard' );
		}
	} );

	// =========================
	// ! External Link Mandate
	// =========================

	document.querySelectorAll( 'a[href^="http"]' ).forEach( anchor => {
		if ( ! anchor.target && ! anchor.href.startsWith( window.location.origin ) ) {
			anchor.setAttribute( 'target', '_blank' );
			anchor.setAttribute( 'rel', 'noreferrer noopener' );
		}
	} );

	// =========================
	// ! Basic Toggles
	// =========================

	delegateEventListener( 'click', '.js-toggle', ( event, trigger ) => {
		const target = determineTarget( trigger );
		if ( target ) {
			event.preventDefault();
			const isOpen = toggleElement( target, null, 'focus' );

			// For global styling that might be needed
			document.body.classList.toggle( `show-${ target.id }`, isOpen );
		}
	} );

	delegateEventListener( 'click', '.js-close', ( event, trigger ) => {
		event.preventDefault();
		toggleElement( trigger.closest( '[aria-hidden="false"]' ), false );
	} );

	// =========================
	// ! Flyout Setup
	// =========================

	const navTemplate = document.getElementById( 'nav_flyout_template' );
	$( '.js-nav-source .sub-menu' ).each( function() {
		const parent = this.parentElement;
		const label = parent.querySelector( '.menu-item-label, .menu-item-link' );

		const menu = navTemplate.content.firstElementChild.cloneNode( true );
		$( '.js-nav-items', menu ).append( this );

		menu.id = `${ parent.id }-flyout`;

		const button = document.createElement( 'button' );
		button.className = 'menu-item-label';
		button.setAttribute( 'aria-controls', menu.id );
		button.innerHTML = label.innerHTML;

		label.after( button );
		label.remove();

		document.body.append( menu );
	} );

	$( '.js-nav-items' ).each( function() {
		const $cards = $( this ).parents( '.js-flyout' ).find( '.js-nav-cards' );

		$( this ).find( '.js-nav-card' ).each( function() {
			const $item = $( this ).parents( '.menu-item' );
			const $link = $item.find( '.menu-item-link' );

			const linkId = $item.attr( 'id' ) + '-link';
			const cardId = $item.attr( 'id' ) + '-card';

			$link.attr( 'id', linkId ).attr( 'aria-controls', cardId );

			const card = this.content.firstElementChild.cloneNode( true );
			card.id = cardId;
			card.setAttribute( 'aria-labelledby', linkId );
			$cards.append( card );
		} );
	} );

	const headerBreakpoint = window.matchMedia( '(max-width: 71.25em)' );
	function maybeHideNavigation() {
		document.getElementById( 'navigation' ).setAttribute( 'aria-hidden', headerBreakpoint.matches );
	}
	maybeHideNavigation();
	if ( typeof headerBreakpoint.addEventListener === 'undefined' ) {
		headerBreakpoint.addListener( maybeHideNavigation );
	} else {
		headerBreakpoint.addEventListener( 'change', maybeHideNavigation );
	}

	// =========================
	// ! Menu Toggles
	// =========================

	const header = document.querySelector( '.buildforce-header' );
	const navButtons = header.querySelectorAll( '.menu-item-label' );
	const navFlyouts = document.querySelectorAll( '.buildforce-flyout' );
	const menuToggle = header.querySelector( '.buildforce-header__menu-toggle' );

	navFlyouts.forEach( flyout => {
		flyout.setAttribute( 'aria-hidden', true );
	} );

	navButtons.forEach( button => {
		button.setAttribute( 'aria-selected', false );

		button.addEventListener( 'click', () => {
			const target = determineTarget( button );
			toggleElement( target, null );

			navFlyouts.forEach( _flyout => {
				if ( _flyout.getAttribute( 'aria-hidden' ) === 'false' && _flyout !== target ) {
					toggleElement( _flyout, false );
				}
			} );
		} );
	} );

	menuToggle.addEventListener( 'click', () => {
		navFlyouts.forEach( flyout => {
			toggleElement( flyout, false );
		} );
	} );

	// =========================
	// ! Modals
	// =========================

	// Add classes to modals automatically
	$( '.buildforce-modal' ).addClass( 'js-modal' ).appendTo( $body );
	$( '.buildforce-modal__close' ).addClass( 'js-modal-close' );
	$( '.buildforce-modal__frame' ).addClass( 'js-modal-backdrop' );

	setupModals();

	// Click-outside handling
	$( document ).on( 'click', '.buildforce-modal', function( event ) {
		if ( $( event.target ).hasClass( 'buildforce-modal' ) ) {
			toggleElement( event.target, false );
		}
	} );

	// =========================
	// ! Tab Set
	// =========================

	// Add classes to tab/tabset blocks automatically
	$( '.buildforce-tab-set' ).addClass( 'js-tab-set' );
	$( '.buildforce-tab-set__nav-item' ).addClass( 'js-tab' );
	$( '.buildforce-tab-panel' ).addClass( 'js-tab-panel' );

	// Mark first tab as auto-open accordion
	$( '.buildforce-tab-set' ).each( function() {
		$( this ).find( '.buildforce-tab-header__toggle' ).first().addClass( 'auto-open' );
	} );

	setupTabs();

	// =========================
	// ! Accordion
	// =========================

	// Group adjacent accordions
	$( '.buildforce-accordion' ).each( function() {
		let $group = $( this ).prev( '.buildforce-accordion-group' );
		if ( $group.length === 0 ) {
			$group = $( '<div class="buildforce-accordion-group"></div>' );
			$group.insertBefore( this );
		}

		$( this ).appendTo( $group );
	} );
	// Add classes to accordion blocks automatically
	$( '.buildforce-accordion-group, .buildforce-tab-set' ).addClass( 'js-accordion-group' );
	$( '.buildforce-accordion__toggle, .buildforce-tab-header__toggle' ).addClass( 'js-accordion-toggle' );
	$( '.buildforce-accordion__content, .buildforce-tab-panel' ).addClass( 'js-accordion-content' );

	setupAccordions( BUILDFORCE.accordionEndpoints || [] );

	// =========================
	// ! Gallery Carousels
	// =========================

	// Prep carousels for functionality
	$( '.buildforce-carousel' ).each( function() {
		$( this ).addClass( 'js-carousel' );
		$( this ).find( '.buildforce-carousel__slides' ).addClass( 'js-carousel-track' )
			.children().addClass( 'js-carousel-slide' );
		$( this ).find( '.buildforce-carousel__pagination' ).addClass( 'js-carousel-pagination' );
	} );

	setupCarousels( { animate: true } );

	// =========================
	// ! Scroller Buttons
	// =========================

	function makeScrollerButton( type ) {
		const button = document.createElement( 'div' );
		button.className = `buildforce-scroller__button ${ type }`;
		button.setAttribute( 'aria-hidden', true );
		return button;
	}

	document.querySelectorAll( '.buildforce-scroller' ).forEach( scroller => {
		const inner = scroller.querySelector( '.buildforce-scroller__inner' );
		const nextButton = makeScrollerButton( 'next' );
		const prevButton = makeScrollerButton( 'prev' );
		const buttons = [ nextButton, prevButton ];

		scroller.append( nextButton, prevButton );

		prevButton.hidden = true;
		inner.addEventListener( 'scroll', () => {
			nextButton.hidden = inner.scrollLeft + inner.offsetWidth >= inner.scrollWidth;
			prevButton.hidden = inner.scrollLeft === 0;
		} );

		buttons.forEach( button => {
			button.addEventListener( 'click', () => {
				if ( button.classList.contains( 'next' ) ) {
					inner.scrollBy( {
						left: inner.offsetWidth,
					} );
				} else {
					inner.scrollBy( {
						left: -1 * inner.offsetWidth,
					} );
				}
			} );
		} );
	} );

	document.addEventListener( 'keyup', event => {
		if ( event.key === 'Tab' ) {
			const scroller = document.activeElement?.closest( '.buildforce-scroller__inner' );
			if ( scroller ) {
				document.activeElement.scrollIntoView( {
					block: 'nearest',
					inline: 'nearest',
				} );
			}
		}
	} );

	// =========================
	// ! Flyout Tabs
	// =========================

	$( '.js-flyout' ).each( function() {
		const $navItems = $( this ).find( '.buildforce-flyout__tabs__nav .menu-item' );
		const $navItemLinks = $( this ).find( '.buildforce-flyout__tabs__nav a' );
		const $contentItems = $( this ).find( '.buildforce-flyout__tabs__content' ).children();

		//Mark first nav/contnent item as current
		$navItems.first().addClass( 'is-active' );
		$contentItems.first().addClass( 'current' );

		function showCard( id ) {
			$navItems.removeClass( 'is-active' ).filter( `[aria-controls="${ id }"]` ).addClass( 'is-active' );
			$contentItems.removeClass( 'current' ).filter( `#${ id }` ).addClass( 'current' );
		}

		$navItemLinks.each( function() {
			const $link = $( this );

			$link.on( 'focus mouseover', function() {
				const id = this.getAttribute( 'aria-controls' );
				showCard( id );
			} );
		} );
	} );

	// =========================
	// ! Dropdown
	// =========================

	$( '.gfield:has(.ginput_container_select)' ).addClass( 'js-dropdown' );

	setupDropdowns();

	// =========================
	// ! Autocomplete Dropdown
	// =========================

	setupAutocompleteDropdowns();

	// =========================
	// ! Flyout Filter Handling
	// =========================

	$( '.filter-flyout' ).each( function() {
		const wrapper = this;
		const container = this.querySelector( '.filter-flyout__options' );

		const count = document.createElement( 'span' );
		count.className = 'filter-flyout__count';
		$( this ).find( '.js-toggle' ).append( count );

		const updateCount = () => {
			count.innerHTML = $( this ).find( 'input:checked' ).length || '';
		};

		$( this ).on( 'change input', updateCount );
		$( this ).closest( '.js-directory' ).on( 'app:update', updateCount );
		updateCount();

		$( this ).parent( 'form' ).submit( updateCount );

		$( document ).on( 'click', function( event ) {
			if ( ! wrapper.contains( event.target ) ) {
				toggleElement( container, false );
			}
		} );
	} );

	// =========================
	// ! Excerpt Handling
	// =========================

	$( document ).on( 'click', '.js-expand', function() {
		const expanded = $( this ).closest( '.is-expandable' ).toggleClass( 'is-expanded' ).hasClass( 'is-expanded' );

		// Swap the text with the cached label
		const label = $( this ).data( 'label' ) || ( expanded ? 'Show less' : 'Show more' );
		$( this ).data( 'label', $( this ).text() );
		$( this ).text( label );
	} );

	// =========================
	// ! Hidden Target Handling
	// =========================

	function handleHiddenTarget( event ) {
		// Get the target element
		const target = document.getElementById( window.location.hash.substring( 1 ) );
		if ( ! target ) {
			return;
		}

		// See if it's within a hidden container
		const container = target.closest( '[id][aria-hidden="true"]' );
		if ( ! container ) {
			return;
		}

		// Find the control for the container
		const control = document.querySelector( `[aria-controls="${ container.id }"], [data-target="${ container.id }"]` );
		if ( ! control ) {
			return;
		}

		// Prevent automatic scolling
		if ( event ) {
			event.preventDefault();
		}

		// Open the container and focus
		control.click();
		target.scrollIntoView();
	}

	window.addEventListener( 'hashchange', handleHiddenTarget );
	handleHiddenTarget();

	// =========================
	// ! Takover Building
	// =========================

	function createTakeover( $content ) {
		const $takeover = $( '<div class="buildforce-takeover"></div>' );
		const $inner = $( '<div class="buildforce-takeover__body"></div>' );
		const $close = $( '<button class="js-close"></button>' ).text( BUILDFORCE.close );

		$takeover.attr( 'aria-hidden', true ).append( $inner );
		$inner.append( $close );
		$inner.append( $content );

		return $takeover;
	}

	$( 'body' ).on( 'toggle-off', '.buildforce-takeover', function() {
		const iframe = this.querySelector( 'iframe' );
		if ( iframe ) {
			const src = iframe.src;
			iframe.src = '';
			iframe.src = src;
		}
	} );

	// =========================
	// ! Embed Popups
	// =========================

	const popups = new Map();
	$( 'body' ).on( 'click', 'a[data-popup]', function( event ) {
		event.preventDefault();
		let $popup = popups.get( this.href );
		if ( ! $popup ) {
			$popup = createTakeover( this.dataset.popup );
			$body.append( $popup );
			popups.set( this.href, $popup );
		}

		toggleElement( $popup[ 0 ] );
	} );

	// =========================
	// ! Embed Popups - Image Popup
	// =========================

	$( '.is-style-modal[id]' ).each( function() {
		const $popup = createTakeover( this );

		const $trigger = $( `a[href="#${ this.id }"]` );
		$trigger.addClass( 'js-toggle' ).attr( 'aria-controls', this.id );

		$popup.attr( 'id', this.id );
		$popup.attr( 'aria-hidden', true );

		$body.append( $popup );
	} );

	// =========================
	// ! Embed Popups - iFrame Popup
	// =========================

	$( '.iframe-takeover[id]' ).each( function() {
		const $trigger = $( `a[href="#${ this.id }"]` );
		$trigger.addClass( 'js-toggle' ).attr( 'aria-controls', this.id );

		$body.append( this );
	} );

	// =========================
	// ! Bookmark/Share Links
	// =========================

	setupShareButtons();

	$( document ).on( 'click', 'a.js-clipboard', e => e.preventDefault() );

	const hrefClipboard = new CliboardJS( 'a.js-clipboard', {
		text( trigger ) {
			return trigger.getAttribute( 'href' );
		},
	} );

	const clipboardTooltipTimeouts = new WeakMap();
	hrefClipboard.on( 'success', e => {
		clearTimeout( clipboardTooltipTimeouts.get( e.trigger ) );
		$( e.trigger ).addClass( 'js-copied' ).attr( 'aria-label', 'Link copied!' );
		const timeout = setTimeout( () => $( e.trigger ).removeClass( 'js-copied' ), 5000 );
		clipboardTooltipTimeouts.set( e.trigger, timeout );
	} );

	// =========================
	// ! Directory Module
	// =========================

	setupDirectoryModules();

	// =========================
	// ! SVG Map
	// =========================

	$( '.buildforce-map' ).each( function() {
		const $container = $( this );
		const $labels = $container.find( '.buildforce-map__label' );

		$labels.each( function() {
			const $label = $( this );
			const $shape = $container.find( `.map-shape[data-map-id="${ this.dataset.mapId }"]` ).addClass( 'enabled' );

			$label.hover( function() {
				$shape.addClass( 'highlighted' );
			}, function() {
				$shape.removeClass( 'highlighted' );
			} );

			$shape.on( 'click', function() {
				$label.click();
			} );
		} );
	} );

	// =========================
	// ! Google Map Stuff
	// =========================

	$( '.js-map-canvas' ).each( function() {
		const config = $( this ).data( 'config' );
		const { center, position, zoom } = config;

		const map = new google.maps.Map( this, {
			center,
			zoom,
			gestureHandling: 'cooperative',
			fullscreenControl: false,
			mapTypeControl: false,
			streetViewControl: false,
			zoomControlOptions: {
				position: google.maps.ControlPosition.RIGHT_BOTTOM,
			},
		} );

		if ( position ) {
			const marker = new google.maps.Marker( {
				position,
			} );

			marker.setMap( map );
		}
	} );

	// =========================
	// ! Conditional Form Utils
	// =========================

	$( '[data-display-condition]' ).each( function() {
		const $this = $( this );
		const [ name, value ] = this.dataset.displayCondition.split( '=' );

		function check() {
			$this.toggleClass( 'hidden', this.value !== value );
		}

		$( `[name="${ name }"]` ).on( 'change', check ).each( check );
	} );

	$( '[data-required-condition]' ).each( function() {
		const $this = $( this );
		const [ name, value ] = this.dataset.requiredCondition.split( '=' );

		function check() {
			$this.attr( 'required', this.value === value );
		}

		$( `[name="${ name }"]` ).on( 'change', check ).each( check );
	} );

	// =========================
	// ! Cookie Consent Handling
	// =========================

	$( '.js-cookie-consent' ).click( function() {
		document.cookie = 'cookieConsent=BuildForce; max-age=86400';
		$( 'body' ).addClass( 'did-cookie-consent' );
	} );
} );
